import { getTranslate } from "react-localize-redux";
import { useSelector } from "react-redux";

const selectTranslate = (state) => ({
	translate: getTranslate(state.localize),
});

const useController = ({ history, urlKey, tab }) => {
	const { translate } = useSelector(selectTranslate);

	const handleClick = () => {
		if (tab) {
			history.push(`/casino?page=${tab}`);
		} else {
			history.push("/casino?page=casino");
		}

		localStorage.removeItem("casino.filters." + urlKey);
	};

	return {
		helpers: { translate },
		handlers: { handleClick },
	};
};

export default useController;
